import {
  ORDER_TYPE,
  SHIPPING_TYPE,
  STATUS,
  TRANSFER_ORDER_TYPE,
} from "constants/order";

export const canShowAddReceiveBusChildButton = ({
  isReceiveBus,
  parentStatus,
}) => Number(isReceiveBus) === 1 && Number(parentStatus) === STATUS.DONE;

export const isChildBarcodeForReceiveBusParent = (parentOrder, barcode) => {
  const scannedBarcode = String(barcode || "").trim();

  if (!scannedBarcode) {
    return false;
  }

  return (
    scannedBarcode !== parentOrder?.order_code &&
    scannedBarcode !== parentOrder?.ref_code
  );
};

export const resolveReceiveBusChildScanAction = ({
  data,
  previousOrder,
  barcode,
  isSendOrder = false,
}) => {
  if (!data?.scan_code || isSendOrder) {
    return { action: "display", orderData: data };
  }

  const prevObject = previousOrder?.object || previousOrder;
  const currentObject = data?.object || data;
  const scannedBarcode = String(barcode || "").trim();
  const isNewOrderScan =
    prevObject?.id &&
    currentObject?.id &&
    Number(prevObject.id) !== Number(currentObject.id);

  if (
    prevObject &&
    !isNewOrderScan &&
    canShowAddReceiveBusChildButton({
      isReceiveBus: prevObject?.is_receive_bus,
      parentStatus: prevObject?.status,
    }) &&
    isChildBarcodeForReceiveBusParent(prevObject, scannedBarcode)
  ) {
    return {
      action: "open_modal",
      orderData: previousOrder,
      initialBarcode: scannedBarcode,
    };
  }

  if (
    canShowAddReceiveBusChildButton({
      isReceiveBus: currentObject?.is_receive_bus,
      parentStatus: currentObject?.status,
    })
  ) {
    return {
      action: "open_modal",
      orderData: data,
      initialBarcode: "",
    };
  }

  return { action: "display", orderData: data };
};

export const orderStatusMode = {
  MAKE: 1, // Tạo đơn
  COORDINATED: 2, // Đã điều phối
  RECEIVED: 3, // Đã nhận hàng
  DELIVERED: 4, // Đã giao hàng
  COMPLETED: 5, // Hoàn tất
  WAITING: 6, // Đang chờ
  CANCELED: 7, // Hủy đơn
  HUB_RECEIVED: 8, // Đã đến Hub
  IN_TRANSIT: 9, // Đang trung chuyển
};

//
export const checkErrorForHandleOrdersCoordinate = ({ selectedRows }) => {
  let messError = "";
  let hub_id = "";
  let isCollector = false;
  const firstSelected = selectedRows[0];
  const allSameType = selectedRows.every(
    row => row.type === firstSelected.type
  );
  if (allSameType) {
    switch (firstSelected.type) {
      case TRANSFER_ORDER_TYPE.RECEIVE: {
        // Đối với đơn nhận mẫu tất cả đơn phải cùng nơi gửi
        const allSameFromHub = selectedRows.every(
          row => row.from_hub === firstSelected.from_hub
        );
        if (!allSameFromHub) {
          messError = "Vui lòng chọn đơn cùng 1 nơi gửi";
        } else {
          hub_id = firstSelected.from_hub;
        }
        break;
      }
      case TRANSFER_ORDER_TYPE.RETURN: {
        // Đối với đơn trả kết quả tất cả đơn phải cùng nơi nhận
        const allSameToHub = selectedRows.every(
          row => row.to_hub === firstSelected.to_hub
        );
        if (!allSameToHub) {
          messError = "Vui lòng chọn đơn cùng 1 nơi nhận";
        } else {
          hub_id = firstSelected.to_hub;
        }
        break;
      }
      case ORDER_TYPE.COLLECTOR.value: {
        // Đối với đơn collector tất cả đơn phải cùng nơi gửi
        const allSameFromHub = selectedRows.every(
          row => row.from_hub === firstSelected.from_hub
        );
        if (!allSameFromHub) {
          messError = "Vui lòng chọn đơn cùng 1 nơi nhận";
        } else {
          hub_id = firstSelected.from_hub;
          isCollector = true;
        }
        break;
      }
      default:
        break;
    }
  } else {
    messError = "Vui lòng chọn cùng 1 loại đơn để điều phối";
  }
  return { messError, hub_id, isCollector };
};

export const checkItemAcceptForUpdateExitsRefCode = item => {
  switch (item.shipping_type) {
    case SHIPPING_TYPE.DVVC:
      return item.status === STATUS.COORDINATED;
    case SHIPPING_TYPE.RUNNER:
      return item.status === STATUS.RECEIVED;
    default:
      return false;
  }
};

export const copyInformationOrderToClipboard = data => {
  const copyInfoText = [];
  data.order_code && copyInfoText.push(`${data.order_code}\n`);
  data.ref_code && copyInfoText.push(`${data.ref_code}\n`);
  data.status && copyInfoText.push(`${data.status}\n`);
  data.customer && copyInfoText.push(`${data.customer}\n`);
  data.contact_name && copyInfoText.push(`${data.contact_name}\n`);
  data.phone && copyInfoText.push(`${data.phone}\n`);
  data.address && copyInfoText.push(`${data.address}\n`);
  data.mainNote && copyInfoText.push(`${data.mainNote}`);

  navigator.clipboard.writeText(copyInfoText.join(""));
};

export const getLableOrderStatus = (orderStatusList, status) => {
  if (orderStatusList?.length > 0 && Array.isArray(orderStatusList) && status) {
    return orderStatusList.find(x => String(status) === x?.value)?.label || "";
  }
  return "";
};
